define('rebrush/components/checkout/closing-loop',[
    'lodash',
    'jquery',
    'cartware_checkout',
    'cartware/components/_base',
    'cartware/components/Dispatcher',
    'cartware/jquery/bem',
    'gigaset/spinner',
], function(
    _,
    $,
    CartwareCheckout,
    Component,
    ComponentDispatcher,
    BEM,
    Spinner
) {
    var MODIFIER_HIDE = 'hide',
        $document = $(document.body);

    return Component.create({
        block:	null,
        showMoreCta: null,
        unfoldContent: null,

        $init: function() {
            this.block = BEM.block('closing-the-loop');
            this.showMoreCta = this.block.getElements('show-more-cta');

            this._bindEvents();
        },

        _bindEvents: function () {
            $document.on('click', '.' + BEM.buildElementClassname('closing-the-loop', 'show-more-cta'), _.bind(this.onClickShowMore, this));
            $document.on('click', '.' + BEM.buildElementClassname('closing-the-loop', 'checkbox'), _.bind(this.onClickCheckbox, this));
        },

        onClickShowMore: function() {
            this.triggerShowMoreContent();
        },
        
        onClickCheckbox: function () {
            var checkbox = $('.' + BEM.buildElementClassname('closing-the-loop', 'checkbox')),
                url = (!checkbox.is(':checked') ? checkbox.data('remove-url') : checkbox.data('addto-url'));

            this._sendAjaxRequest(url, null, _.bind(this.onClickCheckboxCallback, this));
        },

        onClickCheckboxCallback: function (response, status, xhr) {
            const cartTotalsTable = BEM.block('cart-totals');
            const checkoutReviewTotalsTable = $('#checkout-review-table').find('tfoot');
            const totalsResponse = response.totals || null;
            const priceLabel = response.price_label || null;

            if (!totalsResponse) {
                return;
            }

            let totalsTableElement = cartTotalsTable.length ? cartTotalsTable : checkoutReviewTotalsTable;

            if (totalsTableElement.length) {
                totalsTableElement.replaceWith(totalsResponse);
            }

            if (priceLabel) {
                $('.' + BEM.buildElementClassname('closing-the-loop', 'price')).replaceWith(priceLabel).css('font-weight', 600);
            }
        },

        triggerShowMoreContent: function () {
            var unfoldContent = $('.' + BEM.buildElementClassname('closing-the-loop', 'unfold-content'));

            if (unfoldContent.bemHasModifier(MODIFIER_HIDE)) {
                unfoldContent.show();
                unfoldContent.bemRemoveModifier(MODIFIER_HIDE);
            } else {
                unfoldContent.hide();
                unfoldContent.bemAddModifier(MODIFIER_HIDE);
            }
        },

        /**
         * Send ajax request
         *
         * @param url
         * @param data
         * @param callback
         * @param onSuccessCallback
         * @private
         */
        _sendAjaxRequest: function (url, data, callback, onSuccessCallback) {
            data = data || {};

            Spinner.add($document);

            // add isAjax param to avoid caching problems
            if (url.indexOf('isAjax=1') === -1 && typeof data === 'string' && data.indexOf('isAjax=1') === -1) {
                url += url.indexOf('?') === -1 ? '?isAjax=1' : '&isAjax=1';
            }

            url = (this.isSecure === true && url.indexOf('http://') === 0) ? url.replace('http://', 'https://') : url;

            $.ajax(url, {
                method: 'POST',
                data: data
            }).then(_.bind(function (response, status, xhr) {

                if (typeof callback === 'function') {
                    callback(response, status, xhr);
                }

                Spinner.remove();

                if ((response.error || response.success === false)) {
                    console.log(response.error);
                    alert(response.error || 'An error occured. Please try again later.');
                } else {
                    if (typeof onSuccessCallback === 'function') {
                        onSuccessCallback(response, status, xhr);
                    }
                }
            }, this));
        },
    });

});
